<template>
  <div>
    <!-- 激活码明细对话框 -->
    <el-dialog title="激活码使用明细" :visible="visible" width="50%" :modal-append-to-body="false" append-to-body
      @close="handleClose">
      <div class="search-container">
        <div class="search-left">
          <!-- 激活码状态 -->
          <el-select style="margin-right: 20px;" v-model="searchParams.status" placeholder="激活码状态" clearable size="small">
            <!-- 0-未激活，1-已激活，2-已冻结，3-已作废；4-已过期-->
            <el-option label="未激活" :value="0"></el-option>
            <el-option label="已激活" :value="1"></el-option>
            <el-option label="已冻结" :value="2"></el-option>
            <el-option label="已作废" :value="3"></el-option>
          </el-select>
          <!-- 激活码/手机号 -->
          <el-input v-model="searchParams.cdkeyOrMobile" placeholder="激活码/手机号" clearable size="small"></el-input>
        </div>
        <div>
          <!-- 搜索按钮 -->
          <el-button type="primary" size="small" @click="search">搜索</el-button>
        </div>
      </div>
      <el-table :data="list" border style="width: 100%" height="500">
        <el-table-column prop="id" label="Id" width="80"> </el-table-column>
        <el-table-column prop="cdkey" label="激活码" width="200"> </el-table-column>
        <el-table-column prop="name" label="激活码名称" width="200" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">未激活</span>
            <span v-if="scope.row.status === 1">已激活</span>
            <span v-if="scope.row.status === 2">已冻结</span>
            <span v-if="scope.row.status === 3">已作废</span>
            <span v-if="scope.row.status === 4">已过期</span>
          </template>
        </el-table-column>
        <el-table-column prop="expireTime" label="过期时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.expireTime | emptyToDash(scope.row.expireTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="redeemTime" label="激活时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.redeemTime | emptyToDash(scope.row.redeemTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="redeemMobile" label="激活手机号" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.redeemMobile | emptyToDash(scope.row.redeemMobile) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-dialog>

  </div>
</template>

<script>
import ElementPagination from '@/components/ElementPagination';
import Message from '@/components/Message';
import { getActiveCodeDetailList } from '@/api/memberNew/activeCodeGenerate'
export default {
  name: 'WebSaaSDetail',
  components: {
    ElementPagination,
  },
  data() {
    return {
      list: [],
      /** 对话框是否可见 */
      visible: false,
      /** 搜索参数 */
      searchParams: {
        id: null,
        /** 激活码状态 */
        status: "",
        /** 激活码/手机号 */
        cdkeyOrMobile: "",
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },



  methods: {
    //^ ^--------------对话框自身相关-------------^ ^
    async show(id) {
      console.log('批次Id', id);
      this.searchParams.id = id;
      this.getList()
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    /** 关闭对话框 */
    handleClose() {
      this.list = []
      this.searchParams = {
        id: null,
        status: "",
        cdkeyOrMobile: "",
        current: 1,
        size: 10,
        total: 0,
      }
      this.visible = false;
    },
    //^ ^--------------分页相关-------------^ ^
    /** 搜索 */
    search() {
      console.log('搜索', this.searchParams);
      this.searchParams.current = 1
      this.getList();
      Message.success('搜索成功');
    },
    /** 分页获取激活码明细 */
    async getList() {
      const { data } = await getActiveCodeDetailList(this.searchParams);
      console.log('分页的响应', data);
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search-left {
    display: flex;

    ::v-deep .el-input__inner {
      width: 160px !important;
    }
  }
}
</style>